export const login = {
  "Mais facilidade na sua vida!": "Mais facilidade na sua vida!",
  "Nós facilitamos o seu ponto e seus benefícios para": "Nós facilitamos o seu registo de horas e benefícios para",
  "você focar no que realmente": "se concentrar no que realmente",
  "importa!": "importa!",
  "O aplicativo MarQPonto está disponível para Android e iOS": "A aplicação MarQPonto está disponível para Android e iOS",
  "Colaborador": "Colaborador",
  "Login": "Login",
  "Informe o seu e-mail para recuperar sua senha": "Insira o seu e-mail/NIF para recuperar a sua senha",
  "Esqueci minha senha": "Esqueci-me da minha senha",
  "Entrar": "Entrar",
  "Eu sei minha senha": "Eu sei a minha senha",
  "Recuperar": "Recuperar",
  "Aviso": "Aviso",
  "Usuário não encontrado no sistema.Se estiver tentando logar com seu e-mail, revise os dados e tente novamente.Se preferir, você também pode logar usando seu CPF.": "Utilizador não encontrado no sistema.Se estiver a tentar iniciar sessão com o seu e-mail, reveja os dados e tente novamente.Se preferir, também pode iniciar sessão usando o seu NIF.",
  "Usuário não encontrado no sistema.Se estiver tentando logar com CPF, revise os dados e tente novamente.Você também pode logar usando seu e-mail.": "Utilizador não encontrado no sistema.Se estiver a tentar iniciar sessão com NIF, reveja os dados e tente novamente.Também pode iniciar sessão usando o seu e-mail.",
  "Você precisa preencher o Captcha para fazer login no sistema.": "Precisa de preencher o Captcha para iniciar sessão no sistema.",
  "Sucesso!": "Sucesso!",
  "E-mail/CPF": "E-mail/NIF",
  "Password": "Senha"
};


// WEBPACK FOOTER //
// ./src/resources/ptPT/login.js